/**
 * Guarded localStorage/sessionStorage for the first-session panel and checklist.
 * Storage can be missing or throw (private mode, blocked cookies): reads then return the default
 * and writes are dropped, so the state lives for this page load only.
 */
export const PANEL_DISMISSED_KEY = 'dcaclab_fs_panel_dismissed';
export const CHECKLIST_KEY = 'dcaclab_fs_checklist';
// Per tab session: first_run fires once per tab
export const FIRST_RUN_KEY = 'dcaclab_fs_first_run';

const getStore = (kind) => {
  try {
    return window[kind] || null;
  } catch (e) {
    return null;
  }
};

const read = (kind, key) => {
  try {
    const store = getStore(kind);
    return store ? store.getItem(key) : null;
  } catch (e) {
    return null;
  }
};

const write = (kind, key, value) => {
  try {
    const store = getStore(kind);
    if (store) store.setItem(key, value);
  } catch (e) {
    // Storage unavailable: the value lives in memory only
  }
};

export const isPanelDismissed = () => read('localStorage', PANEL_DISMISSED_KEY) === '1';
export const setPanelDismissed = () => write('localStorage', PANEL_DISMISSED_KEY, '1');

const EMPTY_CHECKLIST = { steps: {}, dismissed: false, completed: false };

// { steps: { place: true, ... }, dismissed: bool, completed: bool }
export const readChecklist = () => {
  const raw = read('localStorage', CHECKLIST_KEY);
  if (!raw) return { ...EMPTY_CHECKLIST, steps: {} };
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return { ...EMPTY_CHECKLIST, steps: {} };
    return {
      steps: parsed.steps && typeof parsed.steps === 'object' ? parsed.steps : {},
      dismissed: parsed.dismissed === true,
      completed: parsed.completed === true
    };
  } catch (e) {
    return { ...EMPTY_CHECKLIST, steps: {} };
  }
};

export const writeChecklist = (checklist) => {
  try {
    write('localStorage', CHECKLIST_KEY, JSON.stringify(checklist));
  } catch (e) {
    // JSON or storage failure: keep the in-memory state
  }
};

export const hasFirstRunFired = () => read('sessionStorage', FIRST_RUN_KEY) === '1';
export const setFirstRunFired = () => write('sessionStorage', FIRST_RUN_KEY, '1');
